import { render, staticRenderFns } from "./TabStyle.vue?vue&type=template&id=915e412a&scoped=true"
import script from "./TabStyle.vue?vue&type=script&lang=js"
export * from "./TabStyle.vue?vue&type=script&lang=js"
import style0 from "./TabStyle.vue?vue&type=style&index=0&id=915e412a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915e412a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915e412a')) {
      api.createRecord('915e412a', component.options)
    } else {
      api.reload('915e412a', component.options)
    }
    module.hot.accept("./TabStyle.vue?vue&type=template&id=915e412a&scoped=true", function () {
      api.rerender('915e412a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/TabStyle.vue"
export default component.exports